var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 22,
    viewBox: "0 0 12 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.9 3.50002H11.1V2.34349e-05H7.7C7.7 2.34349e-05 5.6 -0.0999764 4.2 1.70002C4.2 1.70002 3.3 2.60002 3.3 5.10002V7.80002H0V11.6H3.3V21.3H7.1V11.6H10.4L10.9 7.80002H7.2V5.10002C7.2 4.80002 7.3 3.50002 8.9 3.50002Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookImg);
export default __webpack_public_path__ + "static/media/FacebookImg.8176eb9df14cc0768bef2f681665fb86.svg";
export { ForwardRef as ReactComponent };